import { ENTRY_ROUTE_MARKS, type RouteMark } from '@daghfal/core';

/**
 * Every route `App.tsx` declares, marked where its screen shows a child's data, which the shell then draws
 * under the viewer watermark (Q40, Q49). A route added to `App.tsx` and not here fails
 * `routeMarks.test.ts`, so a new screen cannot ship unmarked by accident.
 */
export const CONSOLE_ROUTES: readonly RouteMark[] = [
  ...ENTRY_ROUTE_MARKS,
  // Counts only.
  { route: 'index', path: '/', childData: false },
  { route: 'children', path: '/children', childData: true },
  // An empty form: nothing about a child exists yet.
  { route: 'children/new', path: '/children/new', childData: false },
  // Each imported row's child, by name, with what is wrong with it.
  { route: 'children/import', path: '/children/import', childData: true },
  { route: 'children/registration-gaps', path: '/children/registration-gaps', childData: true },
  { route: 'children/consent-gaps', path: '/children/consent-gaps', childData: true },
  { route: 'children/:id', path: '/children/:id', childData: true },
  // Classes with their counts, not their children.
  { route: 'classes', path: '/classes', childData: false },
  { route: 'academic-years', path: '/academic-years', childData: false },
  // Every active child by name, with their age and next class.
  { route: 'academic-years/:id/rollover', path: '/academic-years/:id/rollover', childData: true },
  { route: 'staff', path: '/staff', childData: false },
  // People and their accounts, not children.
  { route: 'account-requests', path: '/account-requests', childData: false },
  // A class's day and each child's: what they ate, slept, needed.
  { route: 'daily', path: '/daily', childData: true },
  { route: 'attendance', path: '/attendance', childData: true },
  // Pictures of children, with who is in each.
  { route: 'photos', path: '/photos', childData: true },
  { route: 'finance', path: '/finance', childData: true },
  // A complaint names the child it concerns.
  { route: 'complaints', path: '/complaints', childData: true },
  { route: 'complaints/:id', path: '/complaints/:id', childData: true },
  // Incidents and attendance by child.
  { route: 'reports', path: '/reports', childData: true },
  // One incident in full: what happened to a child, and what was done.
  { route: 'incidents/:id', path: '/incidents/:id', childData: true },
  { route: 'settings', path: '/settings', childData: false },
  { route: 'notifications', path: '/notifications', childData: false },
  { route: 'account', path: '/account', childData: false },
  { route: '*', path: '*', childData: false },
];
